import Main from './HelpCenterMain'
import Solicitation from './HelpCenterSolicitation'

export default {
  Main,
  Solicitation,
}
